import React from "react"
import {EpisodeEdit} from "components/backoffice/Media/Episode/EpisodeEdit"

export const EpisodeEditRoute = (props: any) => {

  const {match} = props
  const {params} = match
  const {id} = params

  return <EpisodeEdit id={id} />
}
